import { IDateRange } from "types/frontend_models/time/IDateRange";
import { formatDateToQueryDate } from "functions/formatters/date";

const separator = '-to-';

/**
 * Converts a date range to string format "yyyy-mm-dd-to-yyyy-mm-dd".
 */
export function dateRangeToSearchString(dateRange: IDateRange): string
{
	let search = '';
	if (dateRange.startDate) {
		search += formatDateToQueryDate(dateRange.startDate);
	}
	search += separator;
	if (dateRange.endDate) {
		search += formatDateToQueryDate(dateRange.endDate);
	}

	console.log('dateRangeToSearchString result', search);

	return search;
}

/**
 * Formats a string to an IDateRange. Expects exact format: "yyyy-mm-dd-to-yyyy-mm-dd". 
 * NOTE: Start and end value can be empty. E.g. a start date, but not end date: "2018-01-01-to-"
 * @param dateRangeString 
 */
export function parseDateRangeString(dateRangeString: string): IDateRange
{
	// e.g. "2018-01-01-to-2019-12-31"
	let dateRange: IDateRange = {};
	if (dateRangeString.startsWith(separator)) {
		const subStr = dateRangeString.substr(1);
		dateRange.endDate = new Date(subStr);
	} else if (dateRangeString.endsWith(separator)) {
		const subStr = dateRangeString.substr(0, dateRangeString.length - 1);
		dateRange.startDate = new Date(subStr);
	} else if (dateRangeString.indexOf(separator) !== -1) {
		const splitted = dateRangeString.split(separator);
		dateRange.startDate = new Date(splitted[0]);
		dateRange.endDate = new Date(splitted[1]);
	}

	return dateRange;
}